import Vue from "vue";
import VueRouter from "vue-router";

import { getToken } from "../utils/token";
import {getnGetInfo} from "@/utils/getInfoStorage";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("@/views/index.vue"),
    // 路由重定向
    // redirect: "/home",
    redirect: to => {
      function isLoggedIn() {
        const res = {data:JSON.parse(getnGetInfo())}
        console.log(res.data,"1234567")
        if (res.data === null || res.data === undefined) {
          return 10000}
        if (res.data.user.roleIds=='102'){
          //观察员
          return 102
        }
        else if (res.data.user.roleIds=='101'){
          //联络员
          return 101
        }else if (res.data.user.roleIds=='2') {
          //安全员
          return 2
        }
        else if (res.data.user.roleIds=='100') {
          //管理员
          return 100
        }else {
          return 10000
        }
      }
      // 假设你有一个名为 isLoggedIn 的函数，用于检查用户是否登录
      console.log(isLoggedIn(),"123456789")
      if (isLoggedIn()===102) {
        return '/orderMange';
      } else if (isLoggedIn()===101)  {
        return '/uplist';
      }else if (isLoggedIn()===2) {
        return '/home';
      }else if (isLoggedIn()===100) {
        return '/home';
      } else {
        return '/message';
      }
    },
    // 添加个子页面
    children: [
      {
        path: "home",
        component: () => import("@/views/home.vue"),
        // meta: {
        //   keepAlive:true
        //  }
      },
      {
        path: "noAccepted",
        component: () => import("@/views/list/noAccepted.vue"),
      },
      {
        path: "accepted",
        component: () => import("@/views/list/accepted.vue"),
      },
      {
        path: "Completed",
        component: () => import("@/views/list/Completed.vue"),
      },

      {
        path: "message",
        component: () => import("@/views/message.vue"),
      },
      {
        path: "rwlist",
        component: () => import("@/views/reglist.vue"),
        // meta: {
        //   keepAlive:true
        //  }
      },
      {
        path: "uplist",
        component: () => import("@/views/uplist.vue"),
        // meta: {
        //   keepAlive:true
        // }
      },
      {
        path: "shouwen",
        component: () => import("@/views/shouwen.vue"),
        // meta: {
        //   keepAlive:true
        // }
      },
      {
        path: "zglist",
        component: () => import("@/views/zglist.vue"),
      },
      { path: "/orderMange", component: () => import("@/views/ordermange.vue") },
      { path: "/rank", component: () => import("@/views/rank.vue") },
    ],
  },
  { path: "/login", component: () => import("@/views/login.vue") },
  { path: "/register", component: () => import("@/views/register.vue") },
  { path: "/rwdetail", component: () => import("@/views/rwdetail.vue") },
  { path: "/plandetail", component: () => import("@/views/plandetail.vue") },



  {
    path: "/user",
    component: () => import("@/views/user.vue"),
  },
  {
    path: "/dangerList",
    component: () => import("@/views/dangerdetail.vue"),
  },
  {
    path:"/Changeps",
    component:()=>import("@/views/Changeps.vue")
  },

];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  // 检查是否 登录

  // 登录、注册页面 不需要检查
  if (to.path === "/login" || to.path === "/register") {
    // 不检查，允许访问
    next();
    return;
  }
  // 不是登录页面、注册页面。检查登录
  // 如果没有token 跳转到登录页
  if (!getToken()) {
    next("/login");
    return;
  }
  // 有token 允许放行
  next();
});

export default router;
